import { useSearchParams } from "react-router-dom";

import { RoleType } from "../schema";

export function useInIframe(user?: { role: RoleType }): boolean {
  const isCandidateOrUnknown = !user || user.role === RoleType.Candidate;
  const [params] = useSearchParams();
  return !!params.get("if") && !isCandidateOrUnknown;
}
